<div class="input input-text" [class]="{'error': error, 'disabled': disabled, 'full-width': fullWidth}">
  @if (label) {
    <label [attr.for]="id">{{label}}@if (required) {
      <span class="required-star"> *</span>
    }</label>
  }
  <input
    [disabled]="disabled"
    [attr.id]="id"
    [attr.name]="name"
    [attr.minlength]="minlength"
    [attr.maxlength]="maxlength"
    type="text"
    [(ngModel)]="value"
    (ngModelChange)="onChange($event)"
    [required]="required"
    [attr.placeholder]="placeholder"
    (input)="inputEvent.emit($event)"
    (blur)="onBlur($event)"
    (focus)="focusEvent.emit($event)"
    (keydown)="keyDownEvent.emit($event)"
    (keyup)="keyUpEvent.emit($event)">
  @if (showMessages) {
    <div class="messages">
      @for (error of errorMessages; track error) {
        <small class="error">{{error}}</small>
      }
      <ng-content></ng-content>
    </div>
  }
</div>
